import "swiper/css";
import "swiper/css/pagination";
import "./benefitsSwiper.scss";

import { useRef } from "react";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { getBenefitIcon } from "../../../../utils";
import Typography from "../../../../../../../common/Typography";

const BenefitsSwiper = ({ membership, rewards }) => {
  const swiperRef = useRef(null);

  const handleSlideClick = (index) => {
    if (swiperRef.current && swiperRef.current.slideTo) {
      swiperRef.current.slideTo(index);
    }
  };

  return (
    <div className="benefits-swiper-root" onClick={(e) => e.stopPropagation()}>
      <div className="benefits-head-row">
        <Typography
          weight="semibold"
          customClass="benefits-count"
          style={{
            color: membership?.landing_page_settings?.colors?.text ?? "#000",
          }}
        >
          {rewards?.length} Exiciting Benefits
        </Typography>
        <div id="swiper-pagination-custom" className={`swiper-pagination-custom-${membership?._id}`} />
      </div>
      <Swiper
        spaceBetween={16}
        slidesPerView={"auto"}
        modules={[Pagination]}
        className="benefits-swiper"
        pagination={{
          clickable: true,
          dynamicBullets: true,
          el: `.swiper-pagination-custom-${membership?._id}`,
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {rewards?.map((reward, i) => (
          <SwiperSlide
            key={reward._id}
            className="benefit-card"
            onClick={() => handleSlideClick(i)}
          >
            <div className="benefit-card-content">
              {getBenefitIcon(
                reward?.reward_type,
                membership?.landing_page_settings?.colors?.text
              )}
              <Typography
                style={{
                  color:
                    membership?.landing_page_settings?.colors?.text ?? "#000",
                }}
              >
                {reward?.name}
              </Typography>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BenefitsSwiper;
